export default "__VITE_ASSET__CVTc8qyq__"